module.exports = __webpack_public_path__ + "static/media/ifs_02.2d00d6c8.png";